// extracted by mini-css-extract-plugin
export default {"appLoader":"appLoader__CnRQj"};